import type {Location} from "@/api/apiClient";
import {generateUUID} from "@/utils/uuid";
import type {LocationWithCoordinates} from "../utils/types";
import {useFetchCoordinatesByLocationIdQuery} from "./useFetchCoordinatesByLocationIdQuery";

export function useEnrichLocation() {
    const {fetchCoordinates} = useFetchCoordinatesByLocationIdQuery();

    const enrichLocation = async (
        location: Location,
        suggestSessionId?: string
    ): Promise<LocationWithCoordinates> => {
        // If coordinates are already present, return as is
        if (location.lat != null && location.lon != null) {
            return location as LocationWithCoordinates;
        }

        // If no location ID, we cannot fetch coordinates
        if (!location.id) {
            console.error("Cannot fetch coordinates: missing location ID");
            throw new Error("Cannot fetch coordinates without location ID");
        }

        const sessionId = suggestSessionId ?? generateUUID();

        const coordinates = await fetchCoordinates({
            locationId: location.id,
            suggestSessionId: sessionId,
        });

        return {
            ...location,
            lat: coordinates.lat,
            lon: coordinates.lon,
        };
    };

    return {enrichLocation};
}
